var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSolOptInOptOutManagement01 = function SvgSolOptInOptOutManagement01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol_opt_in_opt_out_management-01_svg2__a",
    x1: -25.19,
    x2: 144.79,
    y1: 151.3,
    y2: -24.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3D43C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#5934b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7523a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#89179f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#9b0d98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_opt_in_opt_out_management-01_svg2__a",
    id: "sol_opt_in_opt_out_management-01_svg2__b",
    x1: -0.37,
    x2: 169.61,
    y1: 175.33,
    y2: -0.3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_opt_in_opt_out_management-01_svg2__a",
    id: "sol_opt_in_opt_out_management-01_svg2__c",
    x1: 14.04,
    x2: 184.01,
    y1: 189.27,
    y2: 13.64
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_opt_in_opt_out_management-01_svg2__a",
    id: "sol_opt_in_opt_out_management-01_svg2__d",
    x1: 40.6,
    x2: 210.58,
    y1: 214.98,
    y2: 39.35
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_opt_in_opt_out_management-01_svg2__a",
    id: "sol_opt_in_opt_out_management-01_svg2__e",
    x1: 13.17,
    x2: 183.14,
    y1: 188.42,
    y2: 12.8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_opt_in_opt_out_management-01_svg2__a",
    id: "sol_opt_in_opt_out_management-01_svg2__f",
    x1: -20.12,
    x2: 149.85,
    y1: 156.2,
    y2: -19.42
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_opt_in_opt_out_management-01_svg2__a",
    id: "sol_opt_in_opt_out_management-01_svg2__g",
    x1: -37.69,
    x2: 132.29,
    y1: 139.2,
    y2: -36.42
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_opt_in_opt_out_management-01_svg2__a",
    id: "sol_opt_in_opt_out_management-01_svg2__h",
    x1: 58.9,
    x2: 228.88,
    y1: 232.69,
    y2: 57.06
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_opt_in_opt_out_management-01_svg2__a",
    id: "sol_opt_in_opt_out_management-01_svg2__i",
    x1: 70.27,
    x2: 240.24,
    y1: 243.69,
    y2: 68.06
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_opt_in_opt_out_management-01_svg2__a",
    id: "sol_opt_in_opt_out_management-01_svg2__j",
    x1: 46.15,
    x2: 216.12,
    y1: 220.34,
    y2: 44.72
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M46.38 92.79h78.32c1.61 0 2.91-1.3 2.91-2.91s-1.3-2.91-2.91-2.91H46.38c-22.36 0-40.55-18.19-40.55-40.59S24.02 5.83 46.38 5.83h18.7c1.61 0 2.91-1.3 2.91-2.91S66.69.01 65.08.01h-18.7C20.81 0 0 20.81 0 46.41s20.81 46.38 46.38 46.38",
    style: {
      fill: "url(#sol_opt_in_opt_out_management-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.83 5.83h76.79c22.36 0 40.55 18.19 40.55 40.59s-18.19 40.55-40.55 40.55h-17.18c-1.61 0-2.91 1.3-2.91 2.91s1.3 2.91 2.91 2.91h17.18c25.57 0 46.38-20.81 46.38-46.41S179.19 0 153.62 0H76.83c-1.61 0-2.91 1.3-2.91 2.91s1.3 2.91 2.91 2.91Z",
    style: {
      fill: "url(#sol_opt_in_opt_out_management-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.85 45.97c0-16.62-13.51-30.15-30.12-30.15s-30.12 13.52-30.12 30.15 13.51 30.14 30.12 30.14 30.12-13.52 30.12-30.14m-54.42 0c0-13.41 10.9-24.32 24.3-24.32s24.3 10.91 24.3 24.32-10.9 24.32-24.3 24.32-24.3-10.91-24.3-24.32",
    style: {
      fill: "url(#sol_opt_in_opt_out_management-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.62 107.21H46.38C20.81 107.21 0 128.02 0 153.62S20.81 200 46.38 200h18.7c1.61 0 2.91-1.3 2.91-2.91s-1.3-2.91-2.91-2.91h-18.7c-22.36 0-40.55-18.19-40.55-40.59s18.19-40.55 40.55-40.55h107.24c22.36 0 40.55 18.19 40.55 40.59s-18.19 40.55-40.55 40.55h-76.8c-1.61 0-2.91 1.3-2.91 2.91s1.3 2.91 2.91 2.91h76.8c25.57 0 46.38-20.81 46.38-46.41s-20.81-46.38-46.38-46.38",
    style: {
      fill: "url(#sol_opt_in_opt_out_management-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.28 123.03c-16.61 0-30.12 13.52-30.12 30.14s13.51 30.15 30.12 30.15S77.4 169.8 77.4 153.17s-13.51-30.14-30.12-30.14m0 54.47c-13.4 0-24.3-10.91-24.3-24.32s10.9-24.32 24.3-24.32 24.3 10.91 24.3 24.32-10.9 24.32-24.3 24.32",
    style: {
      fill: "url(#sol_opt_in_opt_out_management-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.83 62.97c1.61 0 2.91-1.3 2.91-2.91V42.14l13.13 19.01c.88 1.27 2.33 1.81 3.7 1.38 1.41-.44 2.32-1.77 2.32-3.41l-.25-26.4c-.02-1.61-1.42-2.92-2.94-2.88-1.61.02-2.9 1.33-2.88 2.94L93 51.07 79.24 31.15a2.92 2.92 0 0 0-3.26-1.13 2.92 2.92 0 0 0-2.05 2.78v27.27c0 1.61 1.3 2.91 2.91 2.91Z",
    style: {
      fill: "url(#sol_opt_in_opt_out_management-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.14 29.82c-9.14 0-16.57 7.43-16.57 16.57S43 62.96 52.14 62.96s16.57-7.43 16.57-16.57-7.43-16.57-16.57-16.57m0 27.32c-5.93 0-10.75-4.82-10.75-10.75s4.82-10.75 10.75-10.75 10.75 4.82 10.75 10.75-4.82 10.75-10.75 10.75",
    style: {
      fill: "url(#sol_opt_in_opt_out_management-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.74 142.64c1.61 0 2.91-1.3 2.91-2.91s-1.3-2.91-2.91-2.91h-10.99c-1.61 0-2.91 1.3-2.91 2.91v27.12c0 1.61 1.3 2.91 2.91 2.91s2.91-1.3 2.91-2.91v-10.9h7.21c1.61 0 2.91-1.3 2.91-2.91s-1.3-2.91-2.91-2.91h-7.21v-7.48h8.08Z",
    style: {
      fill: "url(#sol_opt_in_opt_out_management-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.81 142.58c1.61 0 2.91-1.3 2.91-2.91s-1.3-2.91-2.91-2.91h-10.99c-1.61 0-2.91 1.3-2.91 2.91v27.12c0 1.61 1.3 2.91 2.91 2.91s2.91-1.3 2.91-2.91v-10.9h7.21c1.61 0 2.91-1.3 2.91-2.91s-1.3-2.91-2.91-2.91h-7.21v-7.48h8.08Z",
    style: {
      fill: "url(#sol_opt_in_opt_out_management-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.61 153.29c0-9.14-7.43-16.57-16.57-16.57s-16.57 7.43-16.57 16.57 7.43 16.57 16.57 16.57 16.57-7.43 16.57-16.57m-27.31 0c0-5.93 4.82-10.75 10.75-10.75s10.75 4.82 10.75 10.75-4.82 10.75-10.75 10.75-10.75-4.82-10.75-10.75",
    style: {
      fill: "url(#sol_opt_in_opt_out_management-01_svg2__j)"
    }
  }));
};
export default SvgSolOptInOptOutManagement01;